import { path } from 'ramda';

import api from '@/api';
import { PAGES_STORE_KEY } from '@/redux/constants';
import { saveAs } from '@/utils/file-saver';

import { ARCHIVE_ROUTE_PATH, FEATURE_NAME, ROUTE_PATH } from './consts';

export const getItemsRoot = path([PAGES_STORE_KEY, FEATURE_NAME, 'items']);

export const getQueryRoot = path([PAGES_STORE_KEY, FEATURE_NAME, 'query']);

export const createReceiptsPageUrl = merchantId =>
  `${ROUTE_PATH.replace(':merchant_id', merchantId)}`;

export const createArchiveReceiptsPageUrl = archiveId =>
  `${ARCHIVE_ROUTE_PATH.replace(':reconciliation_id', archiveId)}`;

export const downloadXls = merchant => {
  const urlParams = new URLSearchParams(window.location.search);
  const limit = Number(urlParams.get('limit')) || 10;
  const page = Number(urlParams.get('page'));
  const offset = page * limit;

  urlParams.set('limit', limit.toString());
  urlParams.set('offset', offset.toString());
  urlParams.set('store_id[eq]', merchant);
  urlParams.delete('page');
  if (!urlParams.has('sort')) {
    urlParams.set('sort', 'bonus_cost');
  }

  api
    .doBlobGet(
      `/merchant-reconciliation-receipts-xlsx-export?${decodeURIComponent(
        urlParams.toString(),
      )}`,
    )
    .then(response => {
      saveAs(response.data, `Сумма потраченных бонусов магазина.xlsx`);
    });
};
